import React from "react";
import { Helmet } from "react-helmet";
import Links from "../../Hooks/Links/Links";
import { motion } from "framer-motion";
import TrailMouse from "../../trailMouse/trailMouse";
import "./Home.css";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Mohammad Nour Khattab - Full Stack Developer | Home</title>
        <meta
          name="description"
          content="Welcome to the portfolio of Mohammad Nour Khattab, a skilled Full Stack Developer specializing in web and mobile application development."
        />
        <meta
          name="keywords"
          content="Full Stack Developer, Web Development, Mohammad Nour Khattab, Frontend, Backend, Portfolio"
        />
        <link rel="canonical" href="https://nour-it.dev" />
      </Helmet>
      <TrailMouse />
      <div
        // initial={{ y: -1500 }}
        // animate={{ y: 0 }}
        // exit={{ y: "-100vh", x: "45%", transition: { duration: 0.2 } }}
        // transition={{ duration: 0.2, ease: "easeInOut", type: "spring", stiffness: "120" }}
        className="home"
      >
        <div className="content">
          <motion.p
            initial={{ y: "-45vh" }}
            animate={{ y: 0 }}
            style={{}}
            exit={{ y: "-45vh", transition: { duration: 0.2 }, fontSize: "36px" }}
            transition={{ y: { duration: 0.2 }, ease: "easeInOut", type: "spring", stiffness: "120" }}
            className="name"
          >
            Nour Khattab
          </motion.p>
          <motion.h1
            initial={{ x: "-100vw" }}
            animate={{ x: 0 }}
            exit={{ x: "100vw", transition: { duration: 0.2 } }}
            transition={{ x: { duration: 0.2 }, ease: "easeInOut", type: "spring", stiffness: "120" }}
            className="desc"
          >
            I'm a Fullstack Developer <br />
          </motion.h1>
          <motion.div
            initial={{ y: "-48vh", x: "48vw" }}
            animate={{ y: 0, x: 0 }}
            transition={{
              x: { duration: 0.2 },
              y: { duration: 0.2 },
              ease: "easeInOut",
              type: "spring",
              stiffness: "120",
            }}
            exit={{ y: "-48vh", x: "48vw", transition: { duration: 0.2 } }}
          >
            <Links />
          </motion.div>
        </div>
        <div className="homeMobile">
          <p className="name">Nour Khattab</p>
          <h2 className="desc">I'm a Fullstack Web Developer</h2>
        </div>
      </div>
    </>
  );
};

export default Home;
